export const PDF_WIDTH_IN = 8.5
export const PDF_HEIGHT_IN = 11

export const PDF_WIDTH_PIXELS = 816
export const PDF_HEIGHT_PIXELS = 1056